import common from './common/link'

export default {
  "name": "Link 6",
  "slug": "link-6",
  "level": 6,
  "assets": {
    "logo": "/themes/link/link-logo.svg",
    "favicon": "/themes/link/link-fav.png"
  },
  "hasRoleSwitch": true,
  "login": {
    "type": "guardTeacherOnly"
  },
  "dbok": [
    {
      "bookId": "626fe00da0baa50013926664",
    },
    {
      "bookId": "626fc5a8a0baa50013925f67",
    },
    {
      "bookId": "6281fc745a2fb70014926801",
    },
    {
      "bookId": "62820dd55a2fb700149270cb",
    },
    {
      "bookId": "630c7b422c420f001300fd1b",
    }
  ],
  addons: {
    overview: {
      extra: {
        title: 'Writing',
        items: [
          {
            title: 'Writing tool',
            cover:
              '/img/writingtool-cover.svg',
            url: 'https://barnetrinn.skriveverktoy.no/?lang=en-GB',
          },
        ],
      },
    },
  },
  ...common
}
